// @flow
// Libs
import React from 'react'
import { Marker, Popup } from 'react-leaflet'
import _size from 'lodash/size'

// Local types
type Props = {
  latLng: Array<number | string>,
}

export default class SearchMarker extends React.Component {
  props: Props

  constructor (props: Props) {
    super(props)
    this.popup = null
    this.onRef = this.onRef.bind(this)
  }

  componentDidMount () {
    if (this.popup) {
      this.popup.openPopup()
    }
  }

  onRef (ref: *): * {
    this.popup = ref && ref.leafletElement
  }

  render (): React.Element<any> {
    return (
      <Marker ref={this.onRef} position={this.props.latLng}>
        {_size(this.props.latLng) &&
        <Popup>
          <div>{this.props.latLng[0]}, {this.props.latLng[1]}</div>
        </Popup>}
      </Marker>
    )
  }
}
